module.exports = __webpack_public_path__ + "media/images/pc/stores/suns/magazine/day03_06_stay-1b5219beec8bec22e6f1f3a289c93548.jpg";